











































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import ISetting from "@/interfaces/setting";

@Component({
  computed: {
    ...mapState("settings", [
      "availableHttpMethods",
      "availableSchemes",
      "availableUserAgents",
    ]),
    ...mapGetters("settings", [
      "followRedirects",
      "selectedHttpMethod",
      "selectedScheme",
      "selectedUserAgent",
      "validateSslCertificate",
    ]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class SettingsGeneral extends Vue {
  // mapState + mapGetters
  hasActiveSubscription!: boolean;

  availableHttpMethods!: Array<string>;
  availableSchemes!: Array<string>;
  availableUserAgents!: Array<object>;
  followRedirects!: boolean;
  selectedHttpMethod!: string;
  selectedScheme!: string;
  selectedUserAgent!: string;
  validateSslCertificate!: boolean;

  followRedirectsLoading = false;
  validateSslCertificateLoading = false;
  httpMethodLoading = false;
  schemeLoading = false;
  userAgentLoading = false;

  set validateSslCertificateLocal(newValue: boolean) {
    const payload = {
      key: "ValidateSslCertificate",
      value: String(newValue), // converting to string, required for correct handling in the api
    };

    this.validateSslCertificateLoading = true;
    this.updateSetting(payload).finally(() => {
      this.validateSslCertificateLoading = false;
    });
  }
  get validateSslCertificateLocal() {
    return this.validateSslCertificate;
  }

  set followRedirectsLocal(newValue: boolean) {
    const payload = {
      key: "FollowRedirects",
      value: String(newValue), // converting to string, required for correct handling in the api
    };

    this.followRedirectsLoading = true;
    this.updateSetting(payload).finally(() => {
      this.followRedirectsLoading = false;
    });
  }
  get followRedirectsLocal(): boolean {
    return this.followRedirects;
  }

  set selectedHttpMethodLocal(newValue: string) {
    const payload = {
      key: "DefaultHttpMethod",
      value: newValue,
    };

    this.httpMethodLoading = true;

    this.updateSetting(payload)
      .then(
        () => {
          // nothing
        },
        () => {
          this.$message({
            message:
              "Something went wrong while updating the HTTP Method setting",
            type: "error",
          });
        }
      )
      .finally(() => {
        this.httpMethodLoading = false;
      });
  }
  get selectedHttpMethodLocal(): string {
    return this.selectedHttpMethod;
  }

  set selectedSchemeLocal(newValue: string) {
    const payload = {
      key: "AddScheme",
      value: newValue,
    };

    this.schemeLoading = true;

    this.updateSetting(payload)
      .then(
        () => {
          // nothing
        },
        () => {
          this.$message({
            message: "Something went wrong while updating the scheme setting",
            type: "error",
          });
        }
      )
      .finally(() => {
        this.schemeLoading = false;
      });
  }
  get selectedSchemeLocal(): string {
    return this.selectedScheme;
  }

  set selectedUserAgentLocal(newValue: string) {
    const payload = {
      key: "UserAgent",
      value: newValue,
    };

    this.userAgentLoading = true;

    this.updateSetting(payload)
      .then(
        () => {
          // nothing
        },
        () => {
          this.$message({
            message:
              "Something went wrong while updating the User-Agent setting",
            type: "error",
          });
        }
      )
      .finally(() => {
        this.userAgentLoading = false;
      });
  }
  get selectedUserAgentLocal(): string {
    return this.selectedUserAgent;
  }

  updateSetting(payload: ISetting) {
    return new Promise((resolve, reject) => {
      this.$store.dispatch("settings/update", payload).then(
        () => {
          resolve();
        },
        () => {
          reject();
        }
      );
    });
  }
}
